import { useStableState } from '@direct-frontend/stdlib';

const emptySet = new Set<string>();

/**
 * Хук для получения стейта выделения строк грида.
 *
 * @param initialState Начальный стейт выделения колонок грида.
 * @returns Объект, работающий с выделением строк грида.
 */
export function useGridRowSelectionState(initialState?: Set<string> | (() => Set<string>)) {
    return useStableState<Set<string>>(initialState ?? emptySet);
}
